import { Box, Button, InputLabel, Stack } from "@mui/material"
import PageElementDTO from "../../../DTO/PageElementDTO"
import InputA from "../../InputA/InputA"
import { useEffect, useState } from "react"
import mainservice from "../../../services/MainService"
import { Getter, Setter } from "../../../services/ComService"
import Spinner from "../../Spinner/Spinner"
import Select from "../../../planningTool/views/Select"
import InputB from "../../InputB/InputB"

const propList = [
  {
    key: 'overAll',
    name: 'Eingangstext',
    fallbackValue: '',
  },
  {
    key: 'topicSelectHeadline',
    name: 'Über Themen Auswahl',
    fallbackValue: 'Select Topic',
  },
  {
    key: 'trainerSelectHeadline',
    name: 'Über Trainer Auswahl',
    fallbackValue: 'Select Coach',
  },
  {
    key: 'noTrainerSelected',
    name: 'Kein Trainer Ausgewählt',
    fallbackValue: 'Please select Coach',
  },
  {
    key: 'langSelectHeadline',
    name: 'Über Sprach Auswahl',
    fallbackValue: 'Select Language',
  },
  {
    key: 'yourMessageHeadline',
    name: 'Über Texteingabe',
    fallbackValue: 'Your Message',
    type: 'textArea'
  },
  {
    key: 'describeMsg',
    name: 'Beschreibung',
    fallbackValue: 'Describe your Topic and when you want to meet.',
    type: 'textArea'
  },
  {
    key: 'sendButton',
    name: 'Send-Button Beschriftung',
    fallbackValue: 'Send',
  },
  {
    key: 'successMsg',
    name: 'Erfolgsnachricht',
    fallbackValue: 'Your Message has been sent - we will get back to you soon',
    type: 'textArea'
  },
  
]



enum Status {
  loading,
  idle,
  sending,
  correct,
  send,
}

interface IDD {
  title: string
  value: string
}

export default function CallToActionForm({pageElement}: {pageElement: PageElementDTO}) {
  const [rerender, setRerender] = useState(0)
  const [status, setStatus] = useState(Status.loading)
  const [msgToUs, setMsgToUs] = useState('')
  const [selectedReceiver, setSelectedReceiver] = useState('nobody')
  const [selectedTopic, setSelectedTopic] = useState('Other')
  const [topicList, setTopicList] = useState<IDD[]>([])
  const [lang, setLang] = useState('English')

  const langs = [
    {
      value: 'English',
      title: 'English'
    },
    {
      value: 'German',
      title: 'German'
    },
    {
      value: 'English or German',
      title: 'English or German'
    },
  ]
  
  const conv = (s: string) =>{
    const session = `${mainservice.nav.getVal('session')}`
    const sessionRegex = /##SESSION##/gi
    return s.replace(sessionRegex, session).replace(/\n/g, '%0A').replace(/<br \/>/g, '%0A')
  }

  const getByKey = (key: string, isConv?: boolean) => {
    const i = propList.find(i => i.key === key)
    const raw = pageElement.getPropVal1(key, '-', i?.fallbackValue || '')
    if (isConv) {
      return conv(raw)
    }
    return raw
  }

  const [receiverList, setReceiverList] = useState<IDD[]>([{
    title: getByKey('noTrainerSelected', true),
    value: 'nobody'
  }])
  const [errMsg, setErrMsg] = useState('')

  useEffect(() => {
    Getter(`callToAction/info`).then((result) => {
      // use info from callToAction/info
      setReceiverList(result.receivers)
      setTopicList(result.topics)
      setStatus(Status.idle)
    })
  }, [])
  const sendForm = async () => {
    if (!selectedReceiver) {
      return
    }
    setStatus(Status.loading)
    const information = {
      bookId: mainservice.nav.getVal('book'),
      msgToUs: msgToUs,
      receiver: selectedReceiver,
      session: mainservice.nav.getVal('session'),
      topic: selectedTopic,
      preferredLanguage: lang,
    }
    Setter(`callToAction/send`, information).then((result) => {
      // define, what happens next
      setStatus(Status.send)
    })
  }
  const overAll = getByKey('overAll', true)
  const renderButton = () => {
    return (
      <div className={`CallToActionForm`}>
        {
          status !== Status.send ? <Box
          >
            <Stack spacing={2}>
              {
                overAll &&
                <Box>
                  <div
                    dangerouslySetInnerHTML={{__html: overAll}}
                  ></div>
                </Box>
              }
              <InputLabel id="demo-simple-select-label1">{getByKey('topicSelectHeadline')}</InputLabel>
              <Select
                options={topicList}
                value={selectedTopic}
                returnVal={async (v) => {
                  setSelectedTopic(v)
                }}
              />
              <InputLabel id="demo-simple-select-label2">{getByKey('trainerSelectHeadline')}</InputLabel>
              <Select
                options={receiverList}
                value={selectedReceiver}
                returnVal={async (v) => {
                  setSelectedReceiver(v)
                }}
              />

              <InputLabel id="demo-simple-select-label2">{getByKey('langSelectHeadline')}</InputLabel>
              <Select
                options={langs}
                value={lang}
                returnVal={async (v) => {
                  setLang(v)
                }}
              />

              {errMsg && <Box
                sx={{
                  color: 'red',
                  backgroundColor: '#fee',
                  padding: '10px',
                  border: '1px solid red',
                  borderRadius: '6px',
                }}
              >{errMsg}</Box>}
              <InputLabel id="demo-simple-select-label3"><div
                  dangerouslySetInnerHTML={{__html: getByKey('yourMessageHeadline', true)}}
                ></div></InputLabel>
              <InputB
                value = {msgToUs}
                type='textarea'
                multiline={true}
                rows={10}
                sendButton='Send'
                returnVal={async (v) => {
                  setMsgToUs(v)
                }}
                delay={0}
                noGrouping={true}
                sx={{height: '200px'}}
              />
              <Box>
                <div
                  dangerouslySetInnerHTML={{__html: getByKey('describeMsg', true)}}
                ></div>
              </Box>
              <Button
                sx={{
                  backgroundColor: 'black',
                  color: '#fff',
                  fontWeight: 'bold',
                }}
                onClick={() => {
                  sendForm()
                }}
              >{getByKey('sendButton')}</Button>
            </Stack>
          </Box> : <Box
          >
            <div
              dangerouslySetInnerHTML={{__html: getByKey('successMsg', true)}}
            ></div>
            
          </Box>
        }
      </div>
    )
  }

  

  const renderAdmin = () => {
    return <div className='CallToActionButton'>
      <div className='w3-row editMode'>
        <div className='w3-col s6'>
          {
            propList.map((p, _i) => <div key={p.key}>
              {p.name}
              <InputA
                key={`${p.key}-${p.name}`}
                value={getByKey(p.key)}
                returnVal={rv => {
                  pageElement.setPropVal(p.key, '-', rv)
                  setRerender(rerender + 1)
                }}
                type={p.type || ''}
              />
            </div>)
          }
        </div>
        <div className='w3-col s6'>
        {
          renderButton()
        }
        </div>
      </div>
      <div className='displayMode'>
      {
        renderButton()
      }
      </div>
    </div>
  }
  if (status === Status.loading) {
    <Spinner />
  }
  if (status === Status.sending) {
    <Spinner />
  }
  if (mainservice.isAdmin()) {
    return renderAdmin()
  }
  return renderButton()
}
